import { Divider, IconButton, makeStyles, Typography } from "@material-ui/core";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import * as React from "react";
import { useState } from "react";
import CreatedByField from "../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { useAuth } from "@airborne/react-admin";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { SectionTitle } from "../../Components/SectionTitle";
import { useAppDataProvider } from "../../dataprovider";
import { Confirm, useNotify } from "react-admin";
import { formatDate } from "../../Helper/MomentHelper";

const useStyles = makeStyles(theme => ({
  root: {
    padding: 30,
  },
}));

const ReliabilityReportRemarkTimeline = ({ reliabilityReportRemark, refresh, isCustomerRelated }) => {
  const { user } = useAuth();
  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [noteData, setNoteData] = useState<any>([] as any);
  const [isCustomerVisibilityDialogOpen, setIsCustomerVisibilityDialogOpen] = useState<boolean>(false);
  const [customerVisibilityRequest, setCustomerVisibilityRequest] = useState<any>(null as any);

  React.useEffect(() => {
    if (
      reliabilityReportRemark !== null &&
      reliabilityReportRemark !== undefined &&
      reliabilityReportRemark.length > 0
    ) {
      if (user?.isCustomer) {
        reliabilityReportRemark = reliabilityReportRemark.filter(x => x.isVisibleToCustomer == true);
      }

      let mappedData = reliabilityReportRemark.map(item => ({
        id: item.id,
        reliabilityReportId: item.reliabilityReportId,
        remark: item.remark,
        isVisibleToCustomer: item.isVisibleToCustomer,
        createdBy: item.createdBy,
        createdDate: formatDate(item.createdDate),
      }));
      setNoteData(mappedData);
    }
  }, [reliabilityReportRemark]);

  const handleCustomerVisibility = e => {
    dataProvider
      .putReliabilityReportRemark(customerVisibilityRequest)
      .then(result => {
        notify(
          customerVisibilityRequest.isVisibleToCustomer
            ? "Successfully made visible to the customer."
            : "Successfully hidden from the customer.",
          "success",
          false,
          true
        );
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => {
        setCustomerVisibilityRequest(null);
        setIsCustomerVisibilityDialogOpen(false);
      });
  };
  const handleCustomerVisibilityDialogOpen = (item: any) => e => {
    var request = { ...item, ...{ isVisibleToCustomer: !item.isVisibleToCustomer } };
    setCustomerVisibilityRequest(request);
    setIsCustomerVisibilityDialogOpen(true);
  };
  const handleCustomerVisibilityDialogClose = () => {
    setCustomerVisibilityRequest(null);
    setIsCustomerVisibilityDialogOpen(false);
  };

  return (
    <div className={classes.root}>
      <Confirm
        isOpen={isCustomerVisibilityDialogOpen}
        title={"Change Customer Visibility"}
        content={"Are you sure?"}
        confirm="Yes"
        cancel="No"
        onConfirm={handleCustomerVisibility}
        onClose={handleCustomerVisibilityDialogClose}
      />
      <SectionTitle label="Reliability Report Remark" />
      <Divider style={{ padding: 0 }} />
      <Timeline align="alternate">
        {noteData.map((item, key) => (
          <TimelineItem key={key}>
            <TimelineOppositeContent>
              <CreatedByField record={item} label={"Created By"} variant={"h6"} />
              <Typography variant="body2" color="textSecondary">
                {item.createdDate}
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="primary">
                {user?.isCustomer || !isCustomerRelated ? (
                  <Visibility />
                ) : (
                  <IconButton
                    color="inherit"
                    style={{ padding: 0 }}
                    title={
                      item.isVisibleToCustomer
                        ? "Click to hide it from the customer."
                        : "Click to make it visible to the customer."
                    }
                    onClick={handleCustomerVisibilityDialogOpen(item)}
                  >
                    {item.isVisibleToCustomer ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                )}
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              {item.remark.match(/.{1,229}/g).map(element => {
                return (
                  <Typography title={element} variant="subtitle2">
                    {element}
                  </Typography>
                );
              })}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
};

export default ReliabilityReportRemarkTimeline;
